import db from "../Db";

import { GetAllCimetierByPlan } from "./../Get/Cimetier";
import { GetFirstZoneByPlan, GetAllZoneByPlan } from "./../Get/Zone";
import { CalculateCoordinatesPlanG } from "./../Calculate/CoordinatesPlanG";
import { IsOracle } from "./../Test/IsOracle";
import { bulkAddWithProgressForSvg, handleError } from "../Function";
import { GetSvgByIdLieu } from "../Get/Svg";
import { GetAllPlan } from "../Get/Plan";
import LieuHistoAcces from "./../../Components/Global/Object/LieuHistoAcces";

var _ = require("lodash");

export async function CreateSvg(update) {
  //const _cimetiers = await GetAllCimetier(0);
  const _plan = await GetAllPlan();
  const _oracle = await IsOracle();
  let index = 0;

  if (update) {
    const lieuASupprimer = LieuHistoAcces.getLieuASupprimer();

    for (let index = 0; index < lieuASupprimer.length; index++) {
      const element = lieuASupprimer[index];

      console.log(element);

      db.SVG.where("LICLEUNIK").equals(element.LICLEUNIK).delete();
    }
  }

  return await Promise.all(
    //_cimetiers.map(async (cimetier) => {
    _plan.map(async (plan) => {
      let zoom;

      //let _firstZone = await GetFirstZone(cimetier.NUMCIME, 1, _oracle);

      // récupère la premiere zone par plan
      const _firstZone = await GetFirstZoneByPlan(plan.NUMPLAN, 1, _oracle);
      if (_firstZone !== undefined) {
        let current = 1;
        let largeur = _firstZone.COORDONNEES.X2 - _firstZone.COORDONNEES.X1;
        let x2 = largeur;

        while (x2 < 640) {
          current++;
          x2 = x2 + largeur;
        }

        zoom = current;

        //const _zone = await GetAllZone(cimetier.NUMCIME, 1);

        // récupérer toutes les zones d'un plan
        const _zone = await GetAllZoneByPlan(plan.NUMPLAN, 1);

        let _dropsAll = [];

        // recupere tous les cimetiere d'un plan
        const _cimetieres = await GetAllCimetierByPlan(plan.NUMPLAN);

        // parcours de tous les cimetiere du plan
        for (let i = 0; i < _cimetieres.length; i++) {
          let cimetier = _cimetieres[i];

          // récupération des svg du cimetiere
          const drops = await CalculateCoordinatesPlanG(_oracle, _zone, cimetier.NUMCIME, zoom, update);

          // Ajout de tous les svg au tableau globale
          _dropsAll = _.concat(_dropsAll, drops);
        }

        return db
          .open()
          .then(() => {
            if (update) {
              let index = 0;

              _.forEach(_dropsAll, (d) => {
                GetSvgByIdLieu(d.LICLEUNIK).then((svg) => {
                  if (svg !== undefined) {
                    _.set(d, "id", svg.id);

                    db.open()
                      .then(() => {
                        db.SVG.put(d).catch((err) => {
                          return handleError(err);
                        });
                      })
                      .catch((err) => {
                        return handleError(err);
                      });
                  } else {
                    db.SVG.add(d).catch((err) => {
                      return handleError(err);
                    });
                  }
                });

                index++;
                if (index === _dropsAll.length - 1) {
                  LieuHistoAcces.resetLieu();
                  LieuHistoAcces.resetLieuASupprimer();

                  return "";
                }
              });
            } else {
              return bulkAddWithProgressForSvg(db.SVG, _dropsAll, 1000).then((res) => {
                console.log(`la sauvegarde des données svg pour le cimetière ${index + 1} est terminé`);

                index++;

                return "";
              });
            }
          })
          .catch((err) => {
            handleError(err);
          });
      } else {
        return "";
      }
    })
  ).then((value) => {
    value = value.map((v) => (v === undefined ? "" : v));

    if (_.uniq(value).length === 1) return "";
  });
}
